import { format } from "date-fns";
import {
  Advertising,
  Arts,
  Background,
  CreateAdvertising,
  Format,
  RequestArtParams,
  RequestBackgroundsParams,
  RequestTemplateParams,
  Template,
} from "../types/studio";
import api from "./api";

export const listArts = async (data: RequestArtParams): Promise<Arts[]> => {
  const params = {
    dataInicio: format(data.startDate, "yyyy-MM-dd"),
    dataFim: format(data.endDate, "yyyy-MM-dd"),
  };

  const response = await api.get(
    "tabloide-digital-p1-prd/prd/crm/getTabloidesDigitais",
    {
      params,
    }
  );

  return response.data;
};

export const listFormats = async (): Promise<Format[]> => {
  const response = await api.get("editor-prd/formats");

  return response.data.content;
};

export const listTemplates = async (
  data: RequestTemplateParams
): Promise<Template[]> => {
  const params: RequestTemplateParams = {
    formats: data.formats,
    tags: "Meu Modelo",
  };
  const response = await api.get("editor-prd/templates", { params });

  return response.data.content;
};

export const listBackgrounds = async (
  data: RequestBackgroundsParams
): Promise<Background[]> => {
  const params: RequestBackgroundsParams = {
    formats: data.formats,
    justCompanyId: 1,
  };
  const response = await api.get("editor-prd/backgrounds", { params });

  return response.data.content;
};

export const createAdvertising = async (
  data: CreateAdvertising
): Promise<Advertising> => {
  const createAdvertisingData = {
    arquivo_tabloide_digital: null,
    copia: false,
    data_fim: format(data.endDate, "yyyy-MM-dd HH:mm"),
    data_inicio: format(data.startDate, "yyyy-MM-dd HH:mm"),
    descricao: "",
    facebookId: "",
    googleId: "",
    id_tabloide_digital: null,
    nome_tabloide: "Propaganda 1",
    produtos: [],
    storeId: null,
    colors: {
      background: "#fff",
      card: "#fff",
      description: "rgba(0, 0, 0, 0.87)",
      percent: "rgba(0, 0, 0, 0.87)",
      productDiscountPrice: "rgba(0, 0, 0, 0.87)",
      productName: "rgba(0, 0, 0, 0.87)",
      productPrice: "rgba(0, 0, 0, 0.87)",
    },
  };
  const response = await api.post(
    "tabloide-digital-p1-prd/prd/crm/postTabloideDigital",
    createAdvertisingData
  );

  return response.data.tabloide;
};
